const HMSOC = () => import('../views/Sic.vue')
const STATS = () => import('./../views/Statisticas.vue')
const Pessoas = () => import('./../views/Pessoas.vue')
const PDOS = () => import('../views/Pedidos.vue')
const LSPDS = () => import('./../relatorios/beneficio.vue')

export default [
  { name: 'viewSic', path: '/home-sic', component: HMSOC, meta: { acl: true } },
  { name: 'viewStatSic', path: '/sic/stats-sic', component: STATS, meta: { acl: true } },
  { name: 'viewPessoas', path: '/sic/pessoas', component: Pessoas, meta: { acl: true } },
  { name: 'viewPedidos', path: '/sic/pedidos', component: PDOS, meta: { acl: true } },
  { name: 'viewListaPedidos', path: '/sic/lista-cadastro-de-pedidos', component: LSPDS, meta: { acl: true } }
]
